var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "fm-debt-banner" }, [
    _c("div", { staticClass: "fm-debt-banner__bar" }, [
      _c(
        "svg",
        {
          staticClass: "fm-debt-banner__icon",
          attrs: {
            width: "18",
            height: "18",
            viewBox: "0 0 24 24",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "aria-hidden": "true",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z",
            },
          }),
          _vm._v(" "),
          _c("line", { attrs: { x1: "12", y1: "9", x2: "12", y2: "13" } }),
          _c("line", { attrs: { x1: "12", y1: "17", x2: "12.01", y2: "17" } }),
        ]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "fm-debt-banner__toggle",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#warningModal",
          },
        },
        [_vm._v("\n      Read the full warning\n    ")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", { staticClass: "fm-debt-banner__text" }, [
      _vm._v(
        "\n      Borrowing money costs money. Free help is available — call the\n      "
      ),
      _c("a", { attrs: { href: "tel:1800007007" } }, [
        _vm._v("National Debt Helpline on 1800 007 007"),
      ]),
      _vm._v("\n      or visit "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.moneysmart.gov.au/",
            target: "_blank",
            rel: "noopener",
          },
        },
        [_vm._v("moneysmart.gov.au")]
      ),
      _vm._v(".\n    "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }